export const calculatePrepaidIntervalCount = (intervalCount: number, prePaidBillingCount?: number) => {
  if (prePaidBillingCount && prePaidBillingCount > 1 && intervalCount !== prePaidBillingCount * intervalCount)
    return prePaidBillingCount * intervalCount;

  return null;
};
